var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-select-theme"},[_c('div',{staticClass:"l-select-theme__inner"},_vm._l((_vm.lockedSets),function(set){return _c('div',{key:set.id,staticClass:"o-primary-btn l-select-theme__item c-select-theme__item",on:{"click":function($event){return _vm.select(set)}}},[_vm._v(" "+_vm._s(set.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }